import { useEffect, useState } from "react";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";

const useExport = () => {
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const audioInfo = summaryCommonStore((state) => state.audioInfo);
  const [speechDraftDone, setSpeechDraftDone] = useState(false);

  const summaryDone = summaryStore((state) => state.summaryStreamsAllDone);
  const srcDone = !!detailInfo?.completeDocFinish;
  const audioDone = !!audioInfo?.audioSrc;

  // 检查发言稿是否存在
  useEffect(() => {
    const checkSpeechDraft = async () => {
      // 非会议所有者不展示发言稿导出
      if (!detailInfo?.isOwner) {
        setSpeechDraftDone(false);
        return;
      }
      const exists = await summaryCommonStore.getState().checkSpeechDraftExists();
      setSpeechDraftDone(exists);
    };
    checkSpeechDraft();
  }, []);

  const showExportBtn = summaryDone || audioDone || srcDone || speechDraftDone;

  return {
    showExportBtn,
    summaryDone,
    srcDone,
    audioDone,
    speechDraftDone
  };
};
export default useExport;
